/*
* Broadcast Theme - Sylnia Butik
*
* Eigen JavaScript. Wordt geladen vanuit layout/theme.liquid.
* Bewerk theme.js NOOIT rechtstreeks; zet aanpassingen hier.
*/

(function () {
  // Add custom code below this line

  /* ------------------------------------------------------------------
     Hoofdfoto laten meewisselen met de gekozen variant.

     Broadcast hoort dit zelf te doen, maar op de productpagina komt dat
     niet altijd door (conflict met apps/custom code). Dit scriptje doet
     het alsnog: het leest de productdata, kijkt welke opties zijn
     aangeklikt, zoekt de bijbehorende variant op en zet diens foto
     actief. Staat de juiste foto al actief, dan gebeurt er niets.
     ------------------------------------------------------------------ */
  function initProductSection(section) {
    if (section.dataset.variantMediaSwap) return;

    var gallery = section.querySelector('product-images');
    var jsonEl = section.querySelector('[data-product-json]');
    if (!gallery || !jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;

    section.dataset.variantMediaSwap = 'true';
    var sectionId = section.getAttribute('data-section-id');

    function selectedValues() {
      var values = [];
      var inputs = section.querySelectorAll('[data-single-option-selector]');

      Array.prototype.forEach.call(inputs, function (input) {
        var raw = input.getAttribute('data-index') || '';
        var index = parseInt(raw.replace('option', ''), 10);
        if (!index) return;
        if (input.type === 'radio' && !input.checked) return;
        values[index - 1] = input.value;
      });

      return values;
    }

    function findVariant(values) {
      if (!values.length) return null;

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var match = true;

        for (var j = 0; j < values.length; j++) {
          if (values[j] !== undefined && variant.options[j] !== values[j]) {
            match = false;
            break;
          }
        }

        if (match) return variant;
      }

      return null;
    }

    function showVariantMedia() {
      var variant = findVariant(selectedValues());
      if (!variant || !variant.featured_media) return;

      var mediaId = sectionId + '-' + variant.featured_media.id;
      if (gallery.getAttribute('data-active-media') === mediaId) return;

      var slides = section.querySelectorAll('.product__slide[data-media-id]');
      if (!slides.length) return;

      var exists = false;
      Array.prototype.forEach.call(slides, function (slide) {
        if (slide.getAttribute('data-media-id') === mediaId) exists = true;
      });
      if (!exists) return;

      gallery.setAttribute('data-active-media', mediaId);

      Array.prototype.forEach.call(slides, function (slide) {
        var isActive = slide.getAttribute('data-media-id') === mediaId;
        slide.classList.toggle('media--active', isActive);
        slide.classList.toggle('media--hidden', !isActive);
      });
    }

    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(showVariantMedia, 60);
    }

    section.addEventListener('change', schedule);
    section.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      if (event.target.closest('label, [data-popout-option]')) schedule();
    });
  }

  function initAllProductSections() {
    var sections = document.querySelectorAll('[data-section-type="product"]');
    Array.prototype.forEach.call(sections, initProductSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductSections);
  } else {
    initAllProductSections();
  }

  // Themabewerker: opnieuw koppelen als de sectie herladen wordt
  document.addEventListener('shopify:section:load', initAllProductSections);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
